import { render, staticRenderFns } from "./editFeePrintSpec.vue?vue&type=template&id=55c2b3da"
import script from "./editFeePrintSpec.vue?vue&type=script&lang=js"
export * from "./editFeePrintSpec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports